export default __webpack_public_path__ + "static/media/don-enchiladas.da71df05.jpeg";